import { DiscountLine, sumDiscounts } from '../../rooms/helpers/sumDiscounts.helper';
import { AvailableRate } from '../types';

type RatePaymentTerms = AvailableRate['payment_terms'];

const zeroedPaymentTerms = (paymentTerms: RatePaymentTerms): RatePaymentTerms => {
  if (!paymentTerms?.amount_due_now) {
    return paymentTerms;
  }

  return {
    ...paymentTerms,
    amount_due_now: { ...paymentTerms.amount_due_now, amount: 0 },
  };
};

const addAmountDueNow = (
  currentTotal: RatePaymentTerms,
  paymentTerms: RatePaymentTerms,
  count: number
): RatePaymentTerms => {
  if (!currentTotal?.amount_due_now) {
    if (!paymentTerms?.amount_due_now) {
      return currentTotal;
    }

    return {
      ...paymentTerms,
      amount_due_now: {
        ...paymentTerms.amount_due_now,
        amount: paymentTerms.amount_due_now.amount * count,
      },
    };
  }

  return {
    ...currentTotal,
    amount_due_now: {
      ...currentTotal.amount_due_now,
      amount:
        currentTotal.amount_due_now.amount + (paymentTerms?.amount_due_now?.amount || 0) * count,
    },
  };
};

export const getTotalFromPricesForRates = (
  availableRates: (AvailableRate & {
    price_per_night?: { amount: number; currency_code: string };
    count: number;
  })[][]
) => {
  const ratePriceMap = new Map();
  const discountLines = new Map<string, DiscountLine[]>();
  availableRates.flat().forEach((rate) => {
    discountLines.set(rate.id, [
      ...(discountLines.get(rate.id) ?? []),
      { discount: rate.discount, price: rate.from_price, count: rate.count },
    ]);

    const currentTotal = ratePriceMap.get(rate.id) || {
      price_per_night: {
        ...rate.price_per_night,
        amount: rate.price_per_night ? 0 : undefined,
      },
      from_price: {
        ...rate.from_price,
        amount: 0,
      },
      payment_terms: zeroedPaymentTerms(rate.payment_terms),
    };
    ratePriceMap.set(rate.id, {
      price_per_night: rate.price_per_night
        ? {
            ...rate.price_per_night,
            amount:
              currentTotal.price_per_night.amount +
              (rate.price_per_night?.amount || 0) * rate.count,
          }
        : undefined,
      from_price: {
        ...rate.from_price,
        amount: currentTotal.from_price.amount + (rate.from_price?.amount || 0) * rate.count,
      },
      payment_terms: addAmountDueNow(currentTotal.payment_terms, rate.payment_terms, rate.count),
    });
  });
  ratePriceMap.forEach((totals, rateId) =>
    ratePriceMap.set(rateId, { ...totals, discount: sumDiscounts(discountLines.get(rateId) ?? []) })
  );
  return ratePriceMap;
};
